"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GreenCard = void 0;
class GreenCard {
}
exports.GreenCard = GreenCard;
//# sourceMappingURL=GreenCard.js.map